import env from '@/env'
import axios from 'axios'
import Cookies from 'js-cookie'
import i18n from "@/i18n";

const involvesStageApi = axios.create({
  baseURL: env.apiV3PublicPath(),
  headers: { 'X-AGILE-CLIENT': 'html_app' },
  withCredentials: true,
});

const KEY_ACCESS_TOKEN = 'involves_access_token';
const KEY_REFRESH_TOKEN = 'involves_refresh_token';

function findAuthorizationCode(link) {
  const url = new URL(link);
  const params = new URLSearchParams(url.search);
  return params.get("code");
}

function getAuthorizationCode(url){
  return new Promise((resolve, reject) => {
    let code = findAuthorizationCode(url);

    if(code == null){
      reject(new Error(i18n.t('authorizationCodeIsMandatory')));
    }

    resolve(code)
  });  
}

function getCognitoToken(code){
  return new Promise((resolve, reject) => {
     involvesStageApi
      .get(`/internal/sso/cognito/authorization/${code}`)
      .then(response => resolve(response.data))
      .catch((error) => {
        reject(new Error(error.response.data.message));
      });
  });
}

function getInvolvesAuthToken(username, password){
  let authentification = {
    tenantName: env.clientId(),
    user: username,
    password: password
  };

  const involvesAuthApi = axios.create({
    baseURL: env.apiInvolvesAuth(),
  });
  
  return involvesAuthApi
    .post(`/api/login`, authentification)
    .then(response => response.data);
}

function generateSession (authorization) {
  return involvesStageApi
    .post(`/internal/sso/sessions`, {accessToken: authorization.accessToken})
    .then(response => response.data)
}


function store (authorization) {
  return new Promise((resolve) => {
    localStorage.setItem(KEY_ACCESS_TOKEN, authorization.accessToken);
    localStorage.setItem(KEY_REFRESH_TOKEN, authorization.refreshToken);
    resolve(authorization);
  });
}

function haveAccessTokens () {
  if(Cookies.get(KEY_ACCESS_TOKEN) == undefined){
    return false;
  }

  if(Cookies.get(KEY_REFRESH_TOKEN) == undefined){
    return false;
  }
  return true;
}

function info () {
  return involvesStageApi
    .get(`/internal/sso/info?platform=WEB`)
    .then(response => response.data)
}

export default {
  findAuthorizationCode,
  getAuthorizationCode,
  getCognitoToken,
  getInvolvesAuthToken,
  generateSession,
  store,
  haveAccessTokens,
  info
}